module.exports = __webpack_public_path__ + "img/148.3859bcd6.jpg";